export default __webpack_public_path__ + "static/media/quoteman_large.edb5a8ec.svg";